import { render, staticRenderFns } from "./chooseMaterialDirectory.vue?vue&type=template&id=4a9bc046&scoped=true&"
import script from "./chooseMaterialDirectory.vue?vue&type=script&lang=js&"
export * from "./chooseMaterialDirectory.vue?vue&type=script&lang=js&"
import style0 from "./chooseMaterialDirectory.vue?vue&type=style&index=0&id=4a9bc046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9bc046",
  null
  
)

export default component.exports